import http from './helpers/httpInterceptor'

const state = () => ({
    employeeList: [],
    employeeSodaList: [],
    createEmployeeSoda: [],
    createEmployeeList:[],
    updateEmployeeSoda: [],
    updateEmployeeList: [],
    deleteEmployeeSoda: []
});

const mutations = {
    EMPLOYEE_LIST (states, data) {
      states.employeeList = data
    },
    EMPLOYEE_SODA_LIST(states, data) {
      states.employeeSodaList = data
    },
    CREATE_EMPLOYEE_SODA(states, data) {
      states.createEmployeeSoda = data
    },
    CREATE_EMPLOYEE_LIST(states, data) {
      states.createEmployeeList = data
    },
    UPDATE_EMPLOYEE_SODA(states, data) {
        states.updateEmployeeSoda = data
    },
    UPDATE_EMPLOYEE_LIST(states, data) {
      states.updateEmployeeList = data
    },
    DELETE_EMPLOYEE_SODA(states, data){
      states.deleteEmployeeSoda = data
    }
};

const actions = {
    getEmployeeList({ commit }, url) {
        return http
            .get("/tms/employee/get-all-employee" + url)
            .then((res) => {
            commit("EMPLOYEE_LIST", res.data);
            return res.data;
            })
            .catch((error) => {
            throw (error)
            });
    },
    getEmployeeSodaData({ commit }, url) {
        return http
            .get("/tms/employee-attendance-check-system-config" + url)
            .then((res) => {
            commit("EMPLOYEE_SODA_LIST", res.data);
            return res.data;
            })
            .catch((error) => {
            throw (error)
            });
    },
    createRequest({ commit }, payload) {
        return http
          .post("/tms/employee-attendance-check-system-config", payload)
          .then((res) => {
            commit("CREATE_EMPLOYEE_SODA", res.data);
            return res.data;
          })
          .catch((error) => {
            throw (error)
          });
    },
    createEmployeeListRequest({ commit }, payload) {
        return http
          .post("/tms/employee/create-employee", payload)
          .then((res) => {
            commit("CREATE_EMPLOYEE_LIST", res.data);
            return res.data;
          })
          .catch((error) => {
            throw (error)
          });
    },
    updateEmployeeSoda({ commit }, payload) {
        return http
          .put('/tms/employee-attendance-check-system-config', payload)
          .then(res => {
            commit("UPDATE_EMPLOYEE_SODA", res.data);
            return res.data
          })
          .catch(err => {
            throw err
          })
    },
    updateEmployeeList({ commit}, payload) {
      return http 
      .put('/tms/employee/update-employee', payload)
      .then(res => {
        commit("UPDATE_EMPLOYEE_LIST", res.data)
        return res.data
      })
      .catch(err => {
        throw err
      })
    },
    deleteEmployeeSoda({commit} , params){
      return http
      .delete('/tms/employee-attendance-check-system-config/'+ params)
      .then(res =>{
        commit("DELETE_EMPLOYEE_SODA", res.data)
        return res.data;
      })
      .catch(err => {
        throw err
      })
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};